import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Context
import { AnnouncementProvider } from './context/AnnouncementContext';

// Pages
import Accueil from './pages/Accueil';
import Services from './pages/Services';
import RendezVous from './pages/RendezVous';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Admin from './pages/Admin';

// Composants
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SocialIcons from './components/SocialIcons';
import AnnouncementBanner from './components/AnnouncementBanner';

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';

  return (
    <div className="App min-h-screen flex flex-col">
      {!isAdmin && <AnnouncementBanner />}
      {!isAdmin && <Navbar />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Accueil />} />
          <Route path="/services" element={<Services />} />
          <Route path="/rendez-vous" element={<RendezVous />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <SocialIcons />}
    </div>
  );
}

function App() {
  return (
    <AnnouncementProvider>
      <Router>
        <AppContent />
      </Router>
    </AnnouncementProvider>
  );
}

export default App;
